import { useCallback, useRef } from 'react';

import { Modal, ModalBody, ModalHeader } from '@change/ds-core-ui/Modal';
import { Text } from '@change/ds-core-ui/Text';

import type { PerimeterXEnforcerChallengeWithBlockedUrl } from '@change-corgi/core/perimeterx';
import { Translate } from '@change-corgi/core-react/i18n';

import { PerimeterXCaptcha } from './PerimeterXCaptcha';

export type Result = {
	success: boolean;
};

export const PerimeterXCaptchaModal = ({
	isOpen,
	setIsOpen,
	pxResponse,
	onResult,
}: {
	isOpen: boolean;
	setIsOpen: (isOpen: boolean) => void;
	pxResponse: PerimeterXEnforcerChallengeWithBlockedUrl;
	onResult: (result: Result) => void;
	// oxlint-disable-next-line explicit-module-boundary-types
}) => {
	const hasResolved = useRef(false);

	const resolveOnce = useCallback(
		(result: Result) => {
			if (hasResolved.current) return;
			hasResolved.current = true;
			onResult(result);
		},
		[onResult],
	);

	const onSuccess = useCallback(() => {
		resolveOnce({ success: true });
	}, [resolveOnce]);

	const onFailure = useCallback(() => {
		resolveOnce({ success: false });
	}, [resolveOnce]);

	return (
		<Modal
			isOpen={isOpen}
			onOpenChange={setIsOpen}
			data-qa="px-captcha-modal"
			size="large"
			isDismissable={false}
			isKeyboardDismissDisabled={false}
			className="z-6000"
		>
			<ModalHeader
				title={
					<Text fontWeight="bold">
						<Translate value="fe.components.px_captcha.title" />
					</Text>
				}
			/>
			<ModalBody>
				<div className="px-0">
					<PerimeterXCaptcha pxResponse={pxResponse} onSuccess={onSuccess} onFailure={onFailure} />
				</div>
			</ModalBody>
		</Modal>
	);
};
